/**
 * Subscription Types
 * 
 * Defines subscription states for premium features.
 * Currently mock/localStorage-based, will swap to Stripe later.
 */

export type SubscriptionTier = 'free' | 'premium';

export type SubscriptionStatus = 
  | 'none'           // Never subscribed
  | 'trialing'       // In 7-day trial
  | 'active'         // Paid and active
  | 'canceled'       // Canceled but still active until period end
  | 'expired';       // Trial or subscription ended

export interface Subscription {
  tier: SubscriptionTier;
  status: SubscriptionStatus;
  trialStartedAt: string | null;    // ISO date
  trialEndsAt: string | null;       // ISO date
  subscribedAt: string | null;      // ISO date
  expiresAt: string | null;         // ISO date (for canceled subs)
  canceledAt: string | null;        // ISO date
}

export const DEFAULT_SUBSCRIPTION: Subscription = {
  tier: 'free',
  status: 'none',
  trialStartedAt: null,
  trialEndsAt: null,
  subscribedAt: null,
  expiresAt: null,
  canceledAt: null,
};

/**
 * Trial duration in days
 */
export const TRIAL_DURATION_DAYS = 7;

/**
 * Premium price display
 */
export const PREMIUM_PRICE = {
  monthly: 1299, // cents
  display: '$12.99/mo',
  name: 'TruePrice Premium',
};
